module.exports = "/fonts/fa-regular-400.eot?261d666b0147c6c5cda07265f98b8f8c";